module.exports = __webpack_public_path__ + "static/img/game4.3e6afcfa.png";